import {Grid, Tab, Tabs} from '@material-ui/core';
import {useState} from 'react';
import {RXPanel} from './RX';
import {SSNPanel} from './SSN';
import {TabPanel} from '../../Core/UI';
import {ParameterStore} from '../../Core/mobx/ParameterStore/ParameterStore';

export function ToolsPanel({
    parameterStore,
    fullWidth = false,
}: {
    parameterStore: ParameterStore | null;
    fullWidth?: boolean;
}) {
    const [tabIndex, setTabIndex] = useState(0);
    return (
        <Grid container spacing={3}>
            <Grid item xs={fullWidth ? 12 : 9} style={{textAlign: 'center'}}>
                <Tabs
                    value={tabIndex}
                    centered
                    onChange={(_e, v) => {
                        setTabIndex(v);
                    }}
                >
                    <Tab label="RX Database" />
                    <Tab label="SSN Verification" />
                </Tabs>
            </Grid>
            <Grid item xs={12}>
                <TabPanel value={tabIndex} index={0}>
                    <RXPanel parameterStore={parameterStore} fullWidth={fullWidth} />
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                    <SSNPanel parameterStore={parameterStore} fullWidth={fullWidth} />
                </TabPanel>
                <TabPanel value={tabIndex} index={2} />
                <TabPanel value={tabIndex} index={3} />
            </Grid>
        </Grid>
    );
}
